import script from "./MiniProgramFloat.vue?vue&type=script&setup=true&lang=js"
export * from "./MiniProgramFloat.vue?vue&type=script&setup=true&lang=js"

import "./MiniProgramFloat.vue?vue&type=style&index=0&id=8ef2aedc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ef2aedc"]])

export default __exports__